import {getCheckoutClient} from '../config/CheckoutClient';
import Polyglot from 'node-polyglot';

function Translations(apiUrl) {
    this.polyglot = null;
    this.mappings = {};
    this.apiUrl = apiUrl;

    this.init = function(locale) {
        this.polyglot = new Polyglot({
            locale: 'en_US'
        });
        if(this.apiUrl) {
            return this.getTranslationsByNamespace(locale, 'Checkout');
        }
    };

    this.fetchTranslations = (locale) => {
        return getCheckoutClient(this.apiUrl).getTranslations(locale).then((result) => {
            let translations = result.body.data.attributes.translations;
            for (const slug in translations) {
                this.mappings[slug] = translations[slug].replace(/%([\w]+)%/g, '%{$1}');
            }
            this.polyglot.extend(this.mappings);
        });
    };

    /**
     * Function to fetch translations for arbitrary slugs
     * @param {string} locale string for locale, e.g. "en_US"
     * @param {Array<string>} slugs array of slugs to fetch translations, e.g. ["not_a_valid_email_address"]
     */
    this.fetchTranslationsBySlug = (locale, slugs) => {
        return getCheckoutClient(this.apiUrl).getTranslationsBySlug(locale, slugs).then((result) => {
            let translations = result.body.data.attributes.translations;
            for (const slug in translations) {
                this.mappings[slug] = translations[slug].replace(/%([\w]+)%/g, '%{$1}');
            }
            this.polyglot.extend(this.mappings);
        });
    };

    this.getTranslationsByNamespace = (locale, namespace) => {
        return getCheckoutClient(this.apiUrl).getTranslationsByNamespace(locale, namespace).then((result) => {
            let translations = result.body.locale_strings;
            for (const slug in translations) {
                this.mappings[slug] = translations[slug].replace(/%([\w]+)%/g, '%{$1}');
            }
            this.polyglot.extend(this.mappings);
        });
    };

    this.t = (stub, interpoplations) => {
        let lowercaseStub = stub.toLowerCase();
        if(!this.mappings[lowercaseStub]) {
            return lowercaseStub;
        }

        return this.polyglot.t(lowercaseStub, interpoplations);
    };
}

export default Translations;
